import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import InteractiveTable from './components/InteractiveTable';
import BlocksOverview from './components/BlocksOverview';
import Timeline from './components/Timeline';
import CognitionChart from './components/CognitionChart';
import FutureBlock from './components/FutureBlock';
import SystemRecipes from './components/SystemRecipes';
import ContentSections from './components/ContentSections';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ElementModal from './components/ElementModal';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [selectedElement, setSelectedElement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleElementClick = (element) => {
    setSelectedElement(element);
    setIsModalOpen(true);
  };

  const handleElementNavigate = (element) => {
    setSelectedElement(element);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedElement(null), 300);
  };

  // Smooth scroll for navigation
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    return () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-dark-950 text-white">
      <Header />
      
      <main>
        <Hero />
        
        <section id="table" className="py-20">
          <InteractiveTable onElementClick={handleElementClick} />
        </section>
        
        <section id="blocks" className="py-20 bg-dark-900/50">
          <BlocksOverview onElementClick={handleElementClick} />
        </section>
        
        <section id="timeline" className="py-20">
          <Timeline />
        </section>
        
        <section id="cognition" className="py-20 bg-dark-900/50">
          <CognitionChart />
        </section>
        
        <section id="future" className="py-20">
          <FutureBlock onElementClick={handleElementClick} />
        </section>
        
        <section id="recipes" className="py-20 bg-dark-900/50">
          <SystemRecipes />
        </section>
        
        <section id="learn" className="py-20">
          <ContentSections />
        </section>
        
        <section id="contact" className="py-20 bg-dark-900/50">
          <ContactSection />
        </section>
      </main>
      
      <Footer />
      
      <ScrollToTop />
      
      <AnimatePresence>
        {isModalOpen && selectedElement && (
          <ElementModal 
            element={selectedElement} 
            onClose={closeModal}
            onNavigate={handleElementNavigate}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
